<template lang="pug">
  div.topbar-toolbar 
    ul.hidden-md-down.notification-list.no-margin.hidden-sm-down.b-grey.b-l.b-r.no-style
      li.inline
        <div class="catalog_number_unread" v-if="showNotice_unread">{{noticeCount}}</div>
        <div class="catalog_number_unfinish" v-if="showNotice_unfinish">{{noticeCount}}</div>
        <a class="notice_icon" v-on:click="checkNotice">
          <i class="iconfont icon-bell"></i>
        </a>
      li.inline
        a(href="#")
          i.iconfont.icon-tasks
</template>

<script>
import { fetch } from '@/utils/api'
export default {
  name: 'Toolbar',
  data () {
    return {
      showNotice_unread: false,
      showNotice_unfinish: false,
      init: true,
      count: 5,
      noticeCount: 0
    }
  },
  created () {
    if (this.init === false) {
      alert('不加载')
      return
    }
    fetch({
      url: '/notice/getUnReadNoticeCount',
      params: {}
    }).then(data => {
      if (data.unRead > 0) {
        this.showNotice_unread = true
        this.noticeCount = data.unRead
      } else if (data.unFinish > 0) {
        this.showNotice_unfinish = true
        this.noticeCount = data.unFinish
      }
      this.init = false
    })
  },
  methods: {
    checkNotice () {
      this.showNotice_unread = false
      this.showNotice_unfinish = false
      this.$router.push('/notice/noticeList')
    },
    load () {
      console.log('加载中')
      this.count += 2
    }
  }
}
</script>

<style lang="sass" scoped>
.topbar-toolbar
  display: none
  line-height: 36px
  ul
    padding: 0 20px
    li
      padding: 0 5px
      a
        .iconfont
          font-size: 20px
.inline
  position: relative
.catalog_number_unread
  position: absolute
  right: 5px
  top: -10px
  float: right
  color: red
  border-radius: 50%
  width: 4px
  height: 4px
  color: #DC143C
  font-weight: bold
.catalog_number_unfinish
  position: absolute
  right: 5px
  top: -10px
  text-align: center
  color: red
  border-radius: 50%
  width: 4px
  height: 4px
  color: #E6A23C
  font-weight: bold
.notice_icon
  background-position: 4px 7px

</style>



// WEBPACK FOOTER //
// Toolbar.vue?0802f832